import { config } from 'affiny-core/env';
import { RoutesNames } from 'affiny-desktop/src/routes/routes-names';
import { createBrowserHistory } from 'history';
import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MainLayout } from './main-layout/MainLayout';
import { ProfileCaptureLayout } from './profile-capture/ProfileCaptureLayout';

interface ILayout {
  children: ReactNode;
}

export const Layout = (props: ILayout) => {
  const history = createBrowserHistory({
    basename: config.env.publicBasePath,
  });
  const location = useLocation();

  const pathname = history.location.pathname;

  const Wrapper =
    pathname.startsWith(RoutesNames.ProfileCapturePrefix) ||
    pathname.startsWith(RoutesNames.ProfileCaptureSafetyTips) ||
    pathname.startsWith(RoutesNames.WhyPremium) ||
    pathname === RoutesNames.LoginDebug
      ? ProfileCaptureLayout
      : MainLayout;

  useEffect(() => {}, [location]);

  return <Wrapper {...props} />;
};
